import { render, staticRenderFns } from "./InquireList.vue?vue&type=template&id=769928f2&"
import script from "./InquireList.vue?vue&type=script&lang=js&"
export * from "./InquireList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports